export const STORAGE_TABLE_NAME_PATTERN = /^[A-Za-z][A-Za-z0-9]{2,62}$/;
export const storageTableNameProblem = (value: string): string | undefined =>
  STORAGE_TABLE_NAME_PATTERN.test(value)
    ? undefined
    : 'Use 3–63 letters and numbers, starting with a letter.';
